module.exports = __webpack_public_path__ + "static/media/04.11e7618b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/04.jpg
// module id = 566
// module chunks = 0